module.exports = __webpack_public_path__ + "static/img/xi_4.0ef06af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_4.jpg
// module id = hKXI
// module chunks = 1